import { useReactiveVar } from '@apollo/client';
import { ModalKey } from 'approot/shared/modal/modal.constants';
import {
  closeGlobalModal,
  globalModalVar,
  globalModalOptionsVar,
} from './global-modals.apollo';

export const useGlobalModal = () => {
  const modalState = useReactiveVar(globalModalVar);
  const modalOptions = useReactiveVar(globalModalOptionsVar);

  return {
    globalModal: modalState || ModalKey.NONE,
    modalOptions,
    closeGlobalModal: closeGlobalModal,
  };
};
